import {createAsyncThunk} from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import {environment} from '../../utils/environment/environment';
import {apiRequestErrorOccured, updateLoading} from '../slices/globalSlice';

const getsupplyChainAvailability = createAsyncThunk(
  'vjo/getsupplyChainAvailability',
  async (data, {dispatch}) => {
    dispatch(updateLoading(true));
    try {
      const baseURL =
        environment.hcServiceBasePostUrl +
        `/getSCSchedulePattern`;
      const response = await axiosInstance.post(baseURL, data);
      dispatch(updateLoading(false));
      return response.data.response;
    } catch (error) {
      dispatch(apiRequestErrorOccured(error));
    }
  },
);

export {getsupplyChainAvailability};
